import queryString from "query-string";
import { API_URL, API_KEY } from "../config";
import { authProvider } from "../authProvider";
import { ApiResponse } from "./response";

export const getHeaders = async (): Promise<Headers> => {
  let token;
  try {
    token = await authProvider.getAccessToken();
  } catch (error) {
    if (
      error.errorCode === "consent_required" ||
      error.errorCode === "interaction_required" ||
      error.errorCode === "login_required"
    ) {
      token = await authProvider.acquireTokenPopup(authProvider.getAuthenticationParameters());
    }
  }
  const headers = new Headers();
  headers.append("Authorization", `Bearer ${token?.accessToken}`);
  headers.append("Content-Type", "application/json");
  return headers;
};

const getApiUrl = (path: string, query?: Query) => {
  const url = queryString.stringifyUrl(
    {
      url: `${API_URL}${path}`,
      query: { ...query },
    },
    { skipNull: true, skipEmptyString: true },
  );

  return url;
};

const getApiHeaders = async (auth = true) => {
  const token = await authProvider.getAccessToken();
  const headers = new Headers();
  if (auth) {
    headers.append("Authorization", `Bearer ${token?.accessToken}`);
  }
  headers.append("Content-Type", "application/json");
  headers.append("x-functions-key", API_KEY);
  return headers;
};

interface Query {
  [key: string]: string | number | undefined | null;
}
export const getFromApi = async <T>(path: string, query?: Query): Promise<ApiResponse<T>> => {
  const headers = await getApiHeaders();
  const response = await fetch(getApiUrl(path, query), { headers });
  if (!response.ok) {
    const { error } = await response.json();
    throw new Error(error);
  }
  return (await response.json()) as ApiResponse<T>;
};

export const postToApi = async (path: string, body: unknown): Promise<Response> => {
  const headers = await getApiHeaders(false);
  const response = await fetch(getApiUrl(path), {
    method: "POST",
    headers,
    body: JSON.stringify(body),
  });
  if (!response.ok) {
    const { error } = await response.json();
    throw new Error(error);
  }
  return response;
};

export const putToApi = async (path: string, body: unknown): Promise<Response> => {
  const headers = await getApiHeaders();
  const response = await fetch(getApiUrl(path), {
    method: "PUT",
    headers,
    body: JSON.stringify(body),
  });
  if (!response.ok) {
    const { error } = await response.json();
    throw new Error(error);
  }
  return response;
};
